import { JobSeekerProfileInternationalGender } from '../__generated__/graphql';
import { convertToStringMonth } from 'Utils/ProfileGraphQLUtils';
import { sortByStartEndYearMonth } from 'Utils/sortByStartEndYearMonth';
function parseDate(dateString) {
    const [year, month, day] = dateString.split('-').map(Number);
    return {
        year: year.toString(),
        month: month.toString(),
        day: day.toString()
    };
}
const formatPhoneNumber = (phoneNumber, countryCode) => {
    // Check if the phone number starts with the country code
    if (phoneNumber.startsWith(countryCode)) {
        // Remove the country code
        const trimmedPhoneNumber = phoneNumber.substring(countryCode.length);
        // Append '0' at the beginning if it doesn't start with zero
        // It is necessary for mobile phone number
        return !trimmedPhoneNumber.startsWith('0') ? `0${trimmedPhoneNumber}` : trimmedPhoneNumber;
    }
    return phoneNumber;
};
export default function mergeResumeWithProfile(resume, indeedResume) {
    resume.basicInfo.firstName = indeedResume?.firstName ?? '';
    resume.basicInfo.lastName = indeedResume?.lastName ?? '';
    resume.basicInfo.firstNameKana = indeedResume?.firstNameFurigana ?? '';
    resume.basicInfo.lastNameKana = indeedResume?.lastNameFurigana ?? '';
    resume.basicInfo.gender = (() => {
        switch (indeedResume?.gender) {
            case JobSeekerProfileInternationalGender.Male:
                return 0;
            case JobSeekerProfileInternationalGender.Female:
                return 1;
            default:
                return 2;
        }
    })();
    resume.basicInfo.genderString = (() => {
        switch (indeedResume?.gender) {
            case JobSeekerProfileInternationalGender.Male:
                return '男性';
            case JobSeekerProfileInternationalGender.Female:
                return '女性';
            default:
                return '';
        }
    })();
    // Set default date if empty
    const parsedDateOfBirth = parseDate(indeedResume?.dateOfBirth || '1990-01-01');
    resume.basicInfo.birthYear = parsedDateOfBirth.year;
    resume.basicInfo.birthMonth = parsedDateOfBirth.month;
    resume.basicInfo.birthDay = parsedDateOfBirth.day;
    if (indeedResume?.location?.postalCode?.length &&
        indeedResume?.location?.postalCode?.length <= 8) {
        resume.contact.zip = indeedResume?.location.postalCode || '';
    }
    const unknownLocation = indeedResume?.location?.unknownLocation ?? '';
    const address = indeedResume?.location?.address ?? '';
    if (unknownLocation && address) {
        resume.contact.address = `${unknownLocation} ${address}`;
    }
    else {
        resume.contact.address = unknownLocation || address;
    }
    resume.contact.buildingName = indeedResume?.location?.address2 ?? '';
    if (indeedResume?.phoneNumber?.length && indeedResume.phoneNumber?.length <= 16) {
        const formattedPhoneNumber = formatPhoneNumber(indeedResume.phoneNumber, '+81'); // Remove JP country code
        if (formattedPhoneNumber.match(/^((090)|(080)|(070))/)) {
            resume.contact.phoneMobile = formattedPhoneNumber;
        }
        else {
            resume.contact.phone = formattedPhoneNumber;
        }
    }
    resume.education = indeedResume?.educations
        ? sortByStartEndYearMonth(indeedResume.educations.map((education) => ({
            name: `${education.school}${education?.degree[0]?.field ? ` ${education.degree[0].field}` : ''}`,
            startYear: education.dateRange?.fromDate?.year?.toString() || '',
            startMonth: convertToStringMonth(education.dateRange?.fromDate?.month) || '',
            endYear: education.dateRange?.toDate?.year?.toString() ||
                education.dateRange?.fromDate?.year?.toString() ||
                '',
            endMonth: convertToStringMonth(education.dateRange?.toDate?.month) ||
                convertToStringMonth(education.dateRange?.fromDate?.month) ||
                '',
            inProgress: !!education.dateRange?.isCurrent || false
        }) // Experience type is somehow used for educations as well
        ))
        : [];
    resume.employment = indeedResume?.workExperiences
        ? sortByStartEndYearMonth(indeedResume.workExperiences.map((workExperience) => ({
            jobType: '',
            employmentStatus: '',
            numOfEmployees: 0,
            companyDescription: '',
            jobDescriptions: [],
            name: workExperience.company,
            startYear: workExperience.dateRange?.fromDate?.year?.toString() || '',
            startMonth: convertToStringMonth(workExperience.dateRange?.fromDate?.month) || '',
            endYear: workExperience.dateRange?.toDate?.year?.toString() ||
                workExperience.dateRange?.fromDate?.year?.toString() ||
                '',
            endMonth: convertToStringMonth(workExperience.dateRange?.toDate?.month) ||
                convertToStringMonth(workExperience.dateRange?.fromDate?.month) ||
                '',
            inProgress: !!workExperience.dateRange?.isCurrent || false
        })))
        : [];
    return resume;
}
